import React from 'react'
import { Text, StyleSheet } from 'react-native'
import theme from './theme'

const styles = StyleSheet.create({
    ultraBigText: {
        fontSize: theme.fontSizes.ultraBigText,
    },
    bigText: {
        fontSize: theme.fontSizes.bigText,
    },
    normalText: {
        fontSize: theme.fontSizes.normalText,
    },
    mediumText: {
        fontSize: theme.fontSizes.mediumText,
    },
    smallText: {
        fontSize: theme.fontSizes.smallText,
    },
    ultraSmallText: {
        fontSize: theme.fontSizes.ultraSmallText,
    },
    normal: {
        fontWeight: theme.fontWeights.normal,
    },
    bold: {
        fontWeight: theme.fontWeights.bold,
    },
    light: {
        fontWeight: theme.fontWeights.light,
    },
    italic: {
        fontStyle: theme.fontStyles.italic,
    },
    colorTextPrimary: {
        color: theme.colors.textPrimary,
    },
    colorTextSecondary: {
        color: theme.colors.textSecondary,
    },
    colorPrimary: {
        color: theme.colors.primary,
    },
    colorSecondary: {
        color: theme.colors.secondary,
    },
    colorGrey: {
        color: theme.colors.grey,
    },
    colorWhite: {
        color: theme.colors.background,
    },
})

export default function StyledText({ color, children, fontSize, fontWeight, fontStyle, ...restOfProps }) {
    const textStyles = [
        styles.text,
        color === 'textPrimary' && styles.colorTextPrimary,
        color === 'textSecondary' && styles.colorTextSecondary,
        color === 'primary' && styles.colorPrimary,
        color === 'secondary' && styles.colorSecondary,
        color === 'grey' && styles.colorGrey,
        color === 'white' && styles.colorWhite,
        fontSize === 'ultraBigText' && styles.ultraBigText,
        fontSize === 'bigText' && styles.bigText,
        fontSize === 'normalText' && styles.normalText,
        fontSize === 'mediumText' && styles.mediumText,
        fontSize === 'smallText' && styles.smallText,
        fontSize === 'ultraSmallText' && styles.ultraSmallText,
        fontWeight === 'bold' && styles.bold,
        fontWeight === 'normal' && styles.normal,
        fontWeight === 'light' && styles.light,
        fontStyle === 'italic' && styles.italic,
    ]
    // Evitar pasar "key" dentro de un objeto de props al Text (warning RN)
    const { key: _ignoredKey, ...safeProps } = restOfProps || {}
    return (
        <Text style={textStyles} {...safeProps}>
            {children}
        </Text>
    )
}
